export const RICH_TEXT_HTML_CLASS = 'prose prose-sm max-w-none rich-text-html';
